// client/src/pages/ProductDetail.js

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function getMediaUrl(path) {
  if (!path) return '/assets/images/placeholder.png';
  return `${process.env.REACT_APP_API_URL}/${path}`;
}

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [mainIndex, setMainIndex] = useState(0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/products/${id}`)
      .then(res => setProduct(res.data))
      .catch(err => console.error(err));
  }, [id]);

  const addToCart = () => {
    if (!product) return;
    let cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existing = cart.find(item => item.id === product._id);
    if (existing) {
      existing.quantity += parseInt(qty);
    } else {
      cart.push({
        id: product._id,
        name: product.name,
        price: product.price,
        image: product.images?.[0],
        quantity: parseInt(qty)
      });
    }
    localStorage.setItem('cart', JSON.stringify(cart));
    alert('Added to cart!');
    window.dispatchEvent(new Event('cart-updated'));
    navigate('/cart');
  };

  if (!product) {
    return <div className="p-4 mt-16">Loading product...</div>;
  }

  const media = [...(product.images || []), ...(product.videos || [])];
  const mainMedia = media[mainIndex] ? getMediaUrl(media[mainIndex]) : null;
  const isVideo = mainMedia && /\.(mp4|mov|avi|webm)$/i.test(mainMedia);

  return (
    <div className="max-w-7xl mx-auto p-4 mt-16">
      <div className="flex flex-col md:flex-row gap-8">
        {/* Left column */}
        <div className="md:w-1/2">
          <div className="border rounded shadow mb-4">
            {mainMedia ? (
              isVideo ? (
                <video
                  key={mainIndex}
                  src={mainMedia}
                  className="w-full h-auto object-contain"
                  controls
                />
              ) : (
                <img
                  key={mainIndex}
                  src={mainMedia}
                  alt="product-media"
                  className="w-full h-auto object-contain"
                />
              )
            ) : (
              <img
                src="/assets/images/placeholder.png"
                alt={product.name}
                className="w-full h-auto object-cover"
              />
            )}
          </div>

          {/* Thumbnails */}
          {media.length > 1 && (
            <div className="flex gap-2 overflow-x-auto">
              {media.map((m, idx) => {
                const thumbUrl = getMediaUrl(m);
                const thumbIsVideo = /\.(mp4|mov|avi|webm)$/i.test(m);
                return (
                  <div
                    key={idx}
                    className={`border p-1 rounded cursor-pointer hover:shadow 
                                ${idx === mainIndex ? 'ring-2 ring-primaryGreen' : ''}`}
                    onClick={() => setMainIndex(idx)}
                  >
                    {thumbIsVideo ? (
                      <video
                        src={thumbUrl}
                        className="w-20 h-20 object-cover"
                      />
                    ) : (
                      <img
                        src={thumbUrl}
                        alt={`thumb-${idx}`}
                        className="w-20 h-20 object-cover"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Right column */}
        <div className="md:w-1/2">
          <h1 className="text-3xl font-bold mb-2">{product.name}</h1>
          <p className="text-primaryGreen font-bold text-xl mb-4">
            ${product.price}
          </p>

          <div
            className="mb-4 text-gray-700 quill-content"
            dangerouslySetInnerHTML={{ __html: product.description }}
          />

          <div className="mb-4">
            <label className="mr-2 font-medium">Quantity:</label>
            <input
              type="number"
              min="1"
              className="border p-1 w-16"
              value={qty}
              onChange={e => setQty(e.target.value)}
            />
          </div>
          <button
            onClick={addToCart}
            className="bg-secondaryGold text-black px-4 py-2 rounded-full 
                       hover:bg-yellow-400 transition"
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}
